let openModalFunction: (() => void) | null = null;

export const setOpenModalFunction = (func: (() => void) | null) => {
  openModalFunction = func;
};

export const openLogoutModal = () => {
  if (openModalFunction) {
    openModalFunction();
  } else {
    console.error("A função para abrir a modal não está definida.");
  }
};
